export default {
  selectData: [],
  sysConfig: []
}
  